module.exports = __webpack_public_path__ + "img/background-main-mobile-decree.17be3e2d.svg";